export const MIN_SIZE = 20;
export const LINK_DESTINATION_NONE = 'none';
export const LINK_DESTINATION_MEDIA = 'media';
export const LINK_DESTINATION_ATTACHMENT = 'attachment';
export const LINK_DESTINATION_CUSTOM = 'custom';
export const NEW_TAB_REL = [ 'noopener' ];
export const ALLOWED_MEDIA_TYPES = [ 'image' ];
export const MEDIA_ID_NO_FEATURED_IMAGE_SET = 0;
export const SIZED_LAYOUTS = [ 'flex', 'grid' ];
export const DEFAULT_MEDIA_SIZE_SLUG = 'full';

/**
 * Delay in milliseconds before preloading an image after hovering.
 * This prevents unnecessary preloading during quick scrolling or mouse movements.
 */
export const IMAGE_PRELOAD_DELAY = 200;
